import approved from './approved.svg';
import notApproved from './notApproved.svg';

export default {
  approved,
  notApproved,
};
